import ErrorText from "components/Status/ErrorText"
import FullSpinner from "components/Status/FullSpinner"
import FullText from "components/Status/FullText"

export default Object.assign({
  Text: FullText,
  Spinner: FullSpinner,
  ErrorText,
})
